import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';
import { IntlService } from '../../core/services/intl.service';

@UntilDestroy({ checkProperties: true })
@Directive({
  selector: '[responsiveImg]',
})
export class ResponsiveImgDirective {
  @Input() url: string;
  @Input() mobileWidth: string;
  @Input() desktopWidth: string;

  public languageChangedSubscription: Subscription;

  private path = 'https://image-uploader-service.firebaseapp.com/landing%2F';

  constructor(private el: ElementRef, private renderer: Renderer2, private intlService: IntlService) {}

  ngOnInit() {
    this.setImage();

    this.languageChangedSubscription = this.intlService.languageChanged().subscribe(() => {
      this.setImage();
    });
  }

  setImage() {
    let url = this.url;
    const availableLanguages = this.intlService.getAvailableLanguageCodes();
    const currentLanguage = this.intlService.getCurrentLanguage();
    if (currentLanguage !== 'pt' && availableLanguages.includes(currentLanguage)) {
      url = this.url
        .replace('.jpeg', `-${currentLanguage}.jpeg`)
        .replace('.jpg', `-${currentLanguage}.jpg`)
        .replace('.png', `-${currentLanguage}.png`);
    }

    this.renderer.setAttribute(this.el.nativeElement, 'src', `${this.path}${url}`);

    if (this.url && this.mobileWidth && this.desktopWidth) {
      const sizes = `(max-width: 800px)  ${this.mobileWidth}w`;

      const srcsetValue = `${this.path}${url}?w=${this.mobileWidth} ${this.mobileWidth}w,
        ${this.path}${url}?w=${this.desktopWidth} ${this.desktopWidth}w`;

      this.renderer.setAttribute(this.el.nativeElement, 'srcset', srcsetValue);
      this.renderer.setAttribute(this.el.nativeElement, 'sizes', sizes);
    }
  }
}
